import { isDefined } from 'notable-common';
import { z } from 'zod';
import { FlowBlockValueNumberSchema } from './numberSchema.js';
import { convertFlowDurationToMilliseconds } from '../../duration/convert.js';
import { FlowDurationUnits } from '../../duration/duration.js';
export const FlowBlockValueTemplateDurationBaseSchema = z.object({
    value: FlowBlockValueNumberSchema({ numberValidationSchema: z.number().gte(0) }),
    units: z.enum(FlowDurationUnits),
});
export function FlowBlockValueTemplateDurationSchema(props = {}) {
    const { pathName, minDuration, maxDuration } = props;
    if (!isDefined(minDuration) && !isDefined(maxDuration)) {
        return FlowBlockValueTemplateDurationBaseSchema;
    }
    // The args type guarantees `pathName` is set alongside any bound; narrow it for
    // the compiler (TypeScript can't correlate it from the min/max check alone).
    if (!isDefined(pathName)) {
        throw new Error('FlowBlockValueTemplateDurationSchema: pathName is required when a bound is set');
    }
    return FlowBlockValueTemplateDurationBaseSchema.superRefine((duration, context) => {
        const numberValue = Number(duration.value);
        // If the value is not a number, it'll be a block value (e.g. {{block.data}})
        if (Number.isNaN(numberValue)) {
            return;
        }
        const milliseconds = convertFlowDurationToMilliseconds({
            ...duration,
            value: numberValue,
        });
        if (isDefined(minDuration) && milliseconds < convertFlowDurationToMilliseconds(minDuration)) {
            return context.addIssue({
                code: 'custom',
                message: `The minimum allowed for ${pathName} is ${String(minDuration.value)} ${minDuration.units}.`,
                path: [pathName],
            });
        }
        if (isDefined(maxDuration) && milliseconds > convertFlowDurationToMilliseconds(maxDuration)) {
            return context.addIssue({
                code: 'custom',
                message: `The maximum allowed for ${pathName} is ${String(maxDuration.value)} ${maxDuration.units}.`,
                path: [pathName],
            });
        }
    });
}
//# sourceMappingURL=templateDuration.js.map